module.exports = __webpack_public_path__ + "static/img/组 2847.70cfaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/auditing/images/组 2847.png
// module id = SK9J
// module chunks = 0